import { createReducer } from '@reduxjs/toolkit'

import { PostResponse } from '@/model/post'

import { deletePost, getPosts, postNamespace } from './post-actions'

const initialState: {
  postList: Record<number, PostResponse[] | undefined>
  postError: boolean | undefined
} = {
  postList: {},
  postError: undefined,
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(getPosts.pending, (draft) => {
    draft.postError = undefined
  })

  builder.addCase(getPosts.fulfilled, (draft, { payload, meta: { arg } }) => {
    const creatorId = arg.creatorId
    if (arg.offset === 0) {
      draft.postList[creatorId] = payload.list
    } else {
      draft.postList[creatorId] = [
        ...(draft.postList[creatorId] || []),
        ...payload.list,
      ]
    }
  })

  builder.addCase(deletePost.fulfilled, (draft, { meta: { arg } }) => {
    const creatorId = arg.creatorId
    if (draft.postList[creatorId]) {
      draft.postList[creatorId] = draft.postList[creatorId].filter(
        (post) => post.post.id !== arg.pid,
      )
    }
  })

  builder.addCase(getPosts.rejected, (draft) => {
    draft.postError = true
  })
})

export default { [postNamespace]: reducer }
